import React, {useState, useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field} from "formik";
import * as Yup from "yup";

import api from "../../../service/api";

import { changeUser } from "../../../redux/actions/login";

import Header from "../../../components/Header";
import Dropzone from "../../../components/Dropzone";
import Input from "../../../components/Input";
import Button from "../../../components/Button";

import { Container, Column, LogoContainer, LogoBackground, Logo, FieldTitle, DropzoneContainer, TranparentButton, ButtonContainer} from "./styles";

//Assets
import perfilImageDefault from "../../../assets/img/logo.png";
import NavTabs from "../../../components/NavTabs";
import routes from "../../../routes/configurationAdmin.routes";
import { addressImage } from "../../../service/domains";

const Configuration = () => {
    const [perfilImage, setPerfilImage] = useState<File>();
    const [logoImg, setLogoImg] = useState<File>();

    const login = useSelector((state: {login: any}) => state.login);
    const dispatch = useDispatch();
    const history = useHistory();
    
    useEffect(() => {
        if(login.user.groups.mc6 === false){
            history.push("/admin/dashboard");
        }
    }, []);

    const formValidationWithYup = Yup.object().shape({
        name: Yup.string().required(),
        email: Yup.string().required(),
        oldPassword: Yup.string(),
        newPassword: Yup.string(),
        repeatNewPassword: Yup.string()
    });

    return(
        <div>
            <Header title="Configuração" subTitle="Configurações gerais e de perfil" subTitleWidth={239}/>
            <NavTabs tabs={routes}/>
                <Formik
                    initialValues={{
                        name: login.user.name,
                        email: login.user.email,
                        oldPassword: "",
                        newPassword: "",
                        repeatNewPassword: ""
                    }}
                    validationSchema={formValidationWithYup}
                    onSubmit={async (values, {resetForm}) => {
                        const logoImgData = new FormData();

                        if(logoImg){
                            logoImgData.append("logomarca", logoImg);

                            const {data} = await api.patch(`/owner/logomarca?id=${login.user.owners.id}`, logoImgData);
                            
                            dispatch(changeUser({...login.user, owners: data}));
                        }

                        if(perfilImage){
                            logoImgData.append("avatar", perfilImage);

                            const {data} = await api.patch("/users/avatar", logoImgData);
                            
                            dispatch(changeUser(data));
                        }

                        if(values.name !== login.user.name || values.email !== login.user.email){
                            try {
                                const { data } = await api.put(`/profile/update?id=${login.user.id}`, {
                                    name: values.name,
                                    email: values.email
                                });

                                dispatch(changeUser(data));
                            } catch (error) {
                                
                            }
                        }

                        if(values.oldPassword !== "" && values.newPassword !== "" && values.repeatNewPassword !== ""){
                            try {
                                const {data} = await api.put("/profile/update", {
                                    "old_password": values.oldPassword,
                                    "password": values.newPassword,
                                    "password_confirmation": values.repeatNewPassword
                                });

                                resetForm();
                            } catch (error) {
                                
                            }
                        }
                    }}
                >
                    {({}) => {
                        return(
                            <>
                                <Container>  
                                        <Column>
                                            <LogoContainer>
                                                <LogoBackground>
                                                    <Logo src={login.user.avatar !== null ? `${addressImage}${login.user.avatar}` : perfilImageDefault}/>
                                                </LogoBackground>
                                            </LogoContainer>

                                            {
                                                login.user.groups.mc6u1 ? (
                                                    <>
                                                        <FieldTitle>Alterar foto de perfil</FieldTitle>
                                                        <DropzoneContainer>
                                                            <div className="w-100">
                                                                <Dropzone onFileUploaded={setPerfilImage} type="image/png"/>
                                                                <div className="d-flex justify-content-center mt-2">
                                                                    <TranparentButton>Baixar arquivos</TranparentButton>
                                                                </div>
                                                            </div>
                                                        </DropzoneContainer>
                                                    </>
                                                ) : null
                                            }

                                            {
                                                true ? ( //login.user.groups.mc6u2
                                                    <>
                                                        <FieldTitle>Logo Padrão</FieldTitle>
                                                        <DropzoneContainer>
                                                            <div className="w-100">
                                                                <Dropzone onFileUploaded={setLogoImg} type="image/png"/>
                                                                <div className="d-flex justify-content-center mt-2">
                                                                    <TranparentButton>Baixar arquivos</TranparentButton>
                                                                </div>
                                                            </div>
                                                        </DropzoneContainer>
                                                    </>
                                                ) : null
                                            }
                                        </Column>

                                        <Column>
                                            {
                                                login.user.groups.mc6u3 ? (
                                                    <Form>
                                                        <FieldTitle>Dados Cadastrais</FieldTitle>
                                                        <Field id="name" name="name" className="inputCustom" placeholder="Nome" as={Input}/>
                                                        <Field id="email" name="email" className="inputCustom" placeholder="Email" as={Input}/>
                                                        {/* <Field id="" name="" className="inputCustom" placeholder="Usuário"/> */}
                                                    </Form>
                                                ) : null
                                            }
                                        </Column>

                                        <Column>
                                            {
                                                login.user.groups.mc6u4 ? (
                                                    <Form>
                                                        <FieldTitle>Alterar Senha</FieldTitle>
                                                        <Field id="oldPassword" type="password" name="oldPassword" className="inputCustom" placeholder="Senha Antiga" as={Input}/>
                                                        <Field id="newPassword" type="password" name="newPassword" className="inputCustom" placeholder="Nova senha" as={Input}/>
                                                        <Field id="repeatNewPassword" type="password" name="repeatNewPassword" className="inputCustom" placeholder="Confirmar nova senha" as={Input}/>
                                                    </Form>
                                                ) : null
                                            }
                                        </Column>
                                </Container>
                                {
                                    login.user.groups.mc6u1 || login.user.groups.mc6u2 || login.user.groups.mc6u3 || login.user.groups.mc6u4 || true ? (
                                        <ButtonContainer>
                                            <Form>
                                                <Button type="submit">Salvar Alterações</Button>
                                            </Form>
                                        </ButtonContainer>
                                    ) : null
                                }
                            </>
                        )
                    }}
                </Formik>
        </div>
    )
}

export default Configuration;